import { apiService } from '../services/apiService';
import { insertPriceHistory } from '../../../api/configuracionSku';

export const useGuardarCambios = () => {
  const guardarCambios = async (
    selectedClient,
    productosModificados,
    competenciasAgregadas,
    competenciasEliminadas,
    preciosCompetenciasModificados,
    setGuardando,
    mostrarToast,
    limpiarCambios,
    setCompetenciasAsignadas,
    setCargandoCompetencias,
    obtenerTodasLasCompetenciasAsignadas,
    productosData,
    fetchSkus,
    setProductosData,
    skusData
  ) => {
    if (!selectedClient) return;

    setGuardando(true);
    const errores = [];
    const exitos = [];

    try {
      // Obtener datos del usuario desde localStorage
      const userData = JSON.parse(localStorage.getItem("userData") || "{}");
      const userUid = userData.uid || userData.id || null;

      // Array para almacenar los cambios de precio para el historial
      const cambiosPrecioHistorial = [];

      // Obtener productos del cliente actual para comparar precios
      const clienteId = selectedClient.id;
      const productosCliente = productosData[clienteId] || [];
      // 1. Actualizar productos modificados y detectar cambios en precios
      for (const [productoId, cambios] of Object.entries(productosModificados)) {
        try {
          // Buscar el producto original para comparar precios
          const productoOriginal = productosCliente.find(p => p.id === parseInt(productoId));
          
          // Detectar si cambió el precio del producto
          if (cambios.precio !== undefined && productoOriginal) {
            const precioAnterior = productoOriginal.precio || 0;
            const precioNuevo = parseFloat(cambios.precio) || 0;
            
            // Si el precio cambió, agregarlo al historial
            if (precioAnterior !== precioNuevo) {
              console.log(`💰 Cambio de precio detectado en producto ${productoId}: ${precioAnterior} → ${precioNuevo}`);
              
              cambiosPrecioHistorial.push({
                idProduct: parseInt(productoId),
                priceDs: precioNuevo,
                rate: 0, // Por defecto 0, como especificó el usuario
                userUid: userUid
              });
            }
          }

          // Actualizar producto (unit y qty) solo si hay cambios en estos campos
          if (cambios.unit !== undefined || cambios.qty !== undefined) {
            await apiService.actualizarProducto(
              parseInt(productoId), 
              cambios.unit, 
              cambios.qty
            );
            exitos.push(`Producto ${productoId} actualizado correctamente`);
          }
        } catch (error) {
          errores.push(`Error al actualizar producto ${productoId}: ${error.message}`);
        }
      }

      // 2. Agregar cambios de precio de competencias al historial
      console.log('💰 Precios de competencias modificados:', preciosCompetenciasModificados);
      
      for (const [sku, precio] of Object.entries(preciosCompetenciasModificados)) {
        if (sku && precio !== undefined) {
          console.log(`💰 Agregando cambio de precio de competencia SKU ${sku}: ${precio}`);
          
          cambiosPrecioHistorial.push({
            idProduct: parseInt(sku),
            priceDs: parseFloat(precio) || 0,
            rate: 0,
            userUid: userUid
          });
        }
      }

      // 3. Recopilar cantidades de competencias para actualización en lote
      const cantidadesCompetencias = [];
      
      console.log('🔍 Recopilando cantidades de competencias para actualización:');
      console.log('Cliente ID:', clienteId);
      console.log('Productos del cliente:', productosCliente.length);
      
      productosCliente.forEach(producto => {
        if (producto.competencias && producto.competencias.length > 0) {
          console.log(`Producto ${producto.id} (${producto.nombre}) - Competencias:`, producto.competencias);
          producto.competencias.forEach((competencia, index) => {
            console.log(`  Competencia ${index}:`, {
              id: competencia.id,
              sku: competencia.sku,
              cantidad: competencia.cantidad,
              esTemporal: competencia.id ? competencia.id.toString().startsWith('comp_') : false
            });
            
            // Solo incluir competencias que tienen ID (existen en la base de datos) y cantidad
            if (competencia.id && !competencia.id.toString().startsWith('comp_') && competencia.sku) {
              // Verificar si tiene cantidad definida (incluso si es 0)
              const cantidad = competencia.cantidad;
              if (cantidad !== undefined && cantidad !== null && cantidad !== '') {
                const cantidadData = {
                  id: parseInt(competencia.sku), // Usar el SKU (ID del producto) en lugar del ID de competencia
                  qty: parseFloat(cantidad) || 0
                };
                console.log('✅ Agregando a actualización:', cantidadData);
                cantidadesCompetencias.push(cantidadData);
              } else {
                console.log('❌ Competencia sin cantidad válida:', competencia);
              }
            } else {
              console.log('❌ Competencia no incluida:', {
                razon: !competencia.id ? 'Sin ID' : 
                       competencia.id.toString().startsWith('comp_') ? 'ID temporal' :
                       !competencia.sku ? 'Sin SKU' : 'Otra razón',
                competencia: competencia
              });
            }
          });
        }
      });
      
      console.log('📊 Total competencias a actualizar:', cantidadesCompetencias.length);
      console.log('📋 Datos finales:', cantidadesCompetencias);

      // 4. Actualizar cantidades de competencias en lote si hay datos
      if (cantidadesCompetencias.length > 0) {
        try {
          await apiService.actualizarCantidadesCompetencias(cantidadesCompetencias);
          exitos.push(`${cantidadesCompetencias.length} cantidades de competencias actualizadas correctamente`);
        } catch (error) {
          errores.push(`Error al actualizar cantidades de competencias: ${error.message}`);
        }
      }

      // 5. Eliminar competencias marcadas para eliminación
      for (const [productoId, competencias] of Object.entries(competenciasEliminadas)) {
        for (const competencia of competencias) {
          try {
            await apiService.eliminarCompetencia(competencia.id);
            exitos.push(`Competencia ${competencia.competenceId} eliminada del producto ${productoId}`);
          } catch (error) {
            errores.push(`Error al eliminar competencia del producto ${productoId}: ${error.message}`);
          }
        }
      }

      // 6. Insertar competencias (solo las que no fueron eliminadas)
      for (const [productoId, competencias] of Object.entries(competenciasAgregadas)) {
        for (const competencia of competencias) {
          try {
            await apiService.insertarCompetencia(
              parseInt(productoId), 
              competencia.competenceId
            );
            exitos.push(`Competencia ${competencia.competenceId} agregada al producto ${productoId}`);
          } catch (error) {
            errores.push(`Error al agregar competencia al producto ${productoId}: ${error.message}`);
          }
        }
      }

      // 7. Guardar historial de precios si hay cambios
      if (cambiosPrecioHistorial.length > 0 && userUid) {
        try {
          console.log(`📊 Guardando historial de ${cambiosPrecioHistorial.length} cambios de precio...`, cambiosPrecioHistorial);
          
          const historialResponse = await insertPriceHistory(cambiosPrecioHistorial);
          
          if (historialResponse.data?.success) {
            console.log('✅ Historial de precios guardado exitosamente');
            exitos.push(`Historial de ${cambiosPrecioHistorial.length} cambio(s) de precio guardado`);
          } else {
            console.warn('⚠️ Advertencia al guardar historial de precios:', historialResponse.data);
            errores.push('Advertencia al guardar historial de precios');
          }
        } catch (historialError) {
          console.error('❌ Error al guardar historial de precios:', historialError);
          errores.push(`Error al guardar historial de precios: ${historialError.message}`);
        }
      } else if (cambiosPrecioHistorial.length > 0 && !userUid) {
        console.warn('⚠️ No se pudo guardar el historial de precios: UID de usuario no disponible');
        errores.push('No se pudo guardar el historial: Usuario no identificado');
      }

      // Mostrar resultados
      if (errores.length > 0) {
        console.error('Errores al guardar:', errores);
        mostrarToast('error', `Se guardó ${exitos.length} cambios, pero hubo ${errores.length} errores`);
      } else {
        console.log('Todos los cambios guardados exitosamente:', exitos);
        mostrarToast('success', `Se guardó ${exitos.length} cambios correctamente`);
        
        // Actualizar productosData con los valores guardados (precio, unidad, cantidad) para que la vista se actualice de inmediato
        if (setProductosData && selectedClient) {
          setProductosData(prev => {
            if (!selectedClient) return prev;
            
            const clienteId = selectedClient.id;
            const productosCliente = prev[clienteId] || [];
            
            const productosActualizados = productosCliente.map(producto => {
              const cambios = productosModificados[producto.id];
              const cambioPrecio = cambiosPrecioHistorial.find(c => c.idProduct === producto.id);
              
              const hayCambios = cambioPrecio || cambios?.unit !== undefined || cambios?.qty !== undefined;
              if (!hayCambios) return producto;
              
              return {
                ...producto,
                ...(cambioPrecio && { precio: cambioPrecio.priceDs }),
                ...(cambios?.unit !== undefined && { unidad: cambios.unit }),
                ...(cambios?.qty !== undefined && { cantidad: cambios.qty })
              };
            });
            
            return {
              ...prev,
              [clienteId]: productosActualizados
            };
          });
        }

        // Recargar skusData para que los inputs muestren los precios actualizados
        if (fetchSkus) {
          try {
            console.log('🔄 Recargando datos de SKUs para reflejar los nuevos precios...');
            await fetchSkus();
          } catch (fetchError) {
            console.warn('No se pudieron recargar los datos de SKUs:', fetchError);
          }
        }
        
        // Limpiar estados de cambios después de actualizar los datos
        // La vista ya muestra los valores correctos desde productosData
        limpiarCambios();
        
        // Recargar competencias asignadas después de guardar
        try {
          setCargandoCompetencias(true);
          const competenciasPorProducto = await obtenerTodasLasCompetenciasAsignadas();
          setCompetenciasAsignadas(competenciasPorProducto);
        } catch (competenceError) {
          console.warn('No se pudieron recargar las competencias asignadas:', competenceError);
        } finally {
          setCargandoCompetencias(false);
        }
      }

    } catch (error) {
      console.error('Error general al guardar:', error);
      mostrarToast('error', `Error al guardar los cambios: ${error.message}`);
    } finally {
      setGuardando(false);
    }
  };

  return { guardarCambios };
};
